import Vue from 'vue'
import { mapState } from 'vuex'
import { SelectOption } from '../io-field/types'

import { SendCommand, Handler } from '@/api/rt'
import { IPanel } from '@/types/view'

export interface Layout {
  i: string
  x: number
  y: number
  w: number
  h: number
  moved: boolean
}

export interface Series {
  id: number
  name: string
  chartType: string
  dataLog: string
  measurement: string
  color: string
  customQuery: string
  edit: boolean
}

export interface Model {
  // eslint-disable-next-line
  attributes: any
  component: string
  // eslint-disable-next-line
  data: any
  layout: Layout
  query: Series[]
  title: string
}

export default Vue.extend({
  props: {
    value: Object,
  },
  data() {
    return {
      model: { attributes: {} } as IPanel,
    }
  },
  computed: {
    ...mapState('tag', { tags: 'items' }),
    optsTag(): SelectOption[] {
      return Object.keys(this.tags).map((uid) => {
        return { value: uid, text: this.tags[uid].name }
      })
    },
  },
  methods: {
    parseInput() {
      this.model = {
        ...this.value,
        query: this.value.query.map((q: string) => JSON.parse(q)),
      }
    },
    // eslint-disable-next-line
    parseModel(): IPanel {
      return {
        ...this.model,
        query: this.model.query.map((q) => JSON.stringify(q)),
      }
    },

    async fetchData() {
      const res = await SendCommand({
        handler: Handler.datalog,
        q: this.model.attributes.query,
      })

      return res
    },
  },
  watch: {
    value: {
      deep: true,
      // eslint-disable-next-line
      handler: function(val: any) {
        const parsedModel = this.parseModel()
        if (JSON.stringify(val) != JSON.stringify(parsedModel)) {
          // this.model = this.value
          this.parseInput()
        }
      },
    },
    model: {
      deep: true,
      handler: function(val) {
        if (JSON.stringify(val) != JSON.stringify(this.value)) {
          this.$emit('input', this.parseModel())
        }
      },
    },
  },
})
